import { computed, observable, action, makeObservable, toJS } from 'mobx'
import { types as t } from '@invisr/mobx-state-tree'
import crudActions from './crud-actions'
import Mapping from './mapping'
import { getNestedDataFields } from '../../utils/datasource-config-utils'

export default t
  .model('state', {
    type: t.optional(t.string, 'State'),
    inputs: t.maybeNull(t.late(() => Mapping))
  })
  .views(self => ({
    get icon () {
      return 'properties'
    },
    get provider () {
      return StateProvider
    }
  }))
  .views(self => ({
    get mapping() {
      return self.inputs
    },
    labels () {
      let customMethods = []
      if (self.inputs && self.inputs.children) {
        customMethods = self.inputs.children
          .filter(c => c.type === 'func')
          .map(c => ({
            key: `data.${c.key}`,
            label: c.key,
            secondaryLabel: 'FUNCTION'
          }))
      }
      return {
        key: (self as any).id as string,
        label: (self as any).name as string,
        childNodes: [
          {
            key: 'data',
            label: 'Data',
            childNodes:
              self.inputs &&
              self.inputs.children &&
              getNestedDataFields(self.inputs.children, 3),
            isExpanded: false
          },
          {
            key: 'methods',
            label: 'Methods',
            isExpanded: false,
            childNodes: [
              {
                key: 'set',
                label: 'set',
                secondaryLabel: 'FUNCTION'
              },
              {
                key: 'refresh',
                label: 'refresh',
                secondaryLabel: 'FUNCTION'
              },
              ...customMethods
            ]
          }
        ]
      }
    }
  }))
  .actions(crudActions)
  .actions(self => ({
    afterCreate () {
      if (!self.inputs) {
        self.update('inputs', {
          type: 'object',
          children: []
        })
      }
    }
  }))

export class StateProvider {
  _data = observable.map({}, { deep: false })
  config

  constructor (config) {
    makeObservable(this, {
      data: computed,
      set: action,
      refresh: action,
      mapper: computed
    })

    this.config = config
  }

  get mapper () {
    return this.config.inputs.mapper
  }

  get data () {
    const data = toJS(this._data)
    const obj = Array.from(data).reduce((o, [k, v]) => {
      o[k] = v
      return o
    }, {})
    return { ...(this.mapper.toProps || {}), ...obj }
  }

  query = () => {
    return this.data
  }

  set = obj => {
    if (obj && typeof obj === 'object') {
      for (const k in obj) this._data.set(k, obj[k])
    }

    return Promise.resolve()
  }

  refresh = () => this._data.clear()
  
}
